'use client'

import PropTypes from 'prop-types'
import { useState } from 'react'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'
import { AddIcon } from '@repo/ui/AddIcon'
import { ClockIcon } from '@repo/ui/ClockIcon'
import { MatterSelect } from '@repo/ui/MatterSelect'
import { useTheme } from '@mui/material/styles'
import { TimeRecordingModeSwitcher } from '../TimeRecordingModeSwitcher/TimeRecordingModeSwitcher'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'

export const TimeRecordingHeader = ({ mode, setMode, setClientFilter, setMatterFilter, onSelectForm }) => {
  const [selectedMatter, setSelectedMatter] = useState(null)
  const theme = useTheme()
  const buttonColor = theme?.palette?.secondary?.main || 'blue'
  const { isOutlookAddin } = useGlobalSettingsStore()

  const handleMatterFilter = (matter) => {
    setSelectedMatter(matter)
    setClientFilter(matter?.clientNo || null)
    setMatterFilter(matter?.matterNo || null)
  }

  return (
    <MUIStack direction="column" sx={{ padding: '0 16px' }} gap={4} data-testid="TimeRecordingHeader">
      {!isOutlookAddin && (
        <MUIStack direction="row" alignItems="center" justifyContent="space-between">
          <MatterSelect
            value={selectedMatter || null}
            onChange={handleMatterFilter}
            sx={{ width: '100%', borderRadius: '20px' }}
            includeBlankMatterOption={false}
            label="Filter by matter"
            menuZindex={9999}
          />
        </MUIStack>
      )}
      <MUIStack
        direction={isOutlookAddin ? 'column-reverse' : 'row'}
        alignItems="center"
        justifyContent={'space-between'}
        flex-wrap="wrap"
        gap={isOutlookAddin ? '30px' : 0}
      >
        <TimeRecordingModeSwitcher mode={mode} onClick={setMode} />

        <MUIStack direction="row" alignItems="center" justifyContent="flex-end" gap={2}>
          <MUIButton
            size="small"
            variant="text"
            onClick={() => onSelectForm('createTimer')}
            sx={{ fontSize: '0.875rem', textTransform: 'none', color: 'secondary.main' }}
          >
            <ClockIcon sx={{ width: '14px', height: '14px', marginRight: '4px', color: buttonColor }} />
            New timer
          </MUIButton>

          <MUIButton
            size="small"
            variant="text"
            onClick={() => onSelectForm('createPosting')}
            sx={{ fontSize: '0.875rem', textTransform: 'none', color: 'secondary.main' }}
          >
            <AddIcon sx={{ width: '14px', height: '14px', marginRight: '4px', color: buttonColor }} />
            Post time
          </MUIButton>
        </MUIStack>
      </MUIStack>
    </MUIStack>
  )
}

TimeRecordingHeader.propTypes = {
  mode: PropTypes.string,
  setMode: PropTypes.func,
  setClientFilter: PropTypes.func,
  setMatterFilter: PropTypes.func,
  onSelectForm: PropTypes.func
}
